import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, projUrl}) => {
    return (
        <Col sm={6} md={4}>
            <a href={projUrl} className="proj-link">
            <div className="proj-imgbx">
                <img src={imgUrl} className="proj-img"/>
                <div className="proj-txt">
                    <h4>{title}</h4>
                    <span>{description}</span>
                </div>
            </div>
            </a>
        </Col>
    )
}